var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// evm/getBestTrade.ts
import { TradeType as TradeType5 } from "@pancakeswap/sdk";

// evm/getBestTradeFromStablePools.ts
import { Price as Price2, TradeType as TradeType2 } from "@pancakeswap/sdk";

// evm/types/bestTrade.ts
var RouteType = /* @__PURE__ */ ((RouteType2) => {
  RouteType2[RouteType2["V2"] = 0] = "V2";
  RouteType2[RouteType2["STABLE_SWAP"] = 1] = "STABLE_SWAP";
  RouteType2[RouteType2["MIXED"] = 2] = "MIXED";
  return RouteType2;
})(RouteType || {});

// evm/utils/pair.ts
function involvesToken(pair, token) {
  const { token0, token1 } = pair;
  return token0.wrapped.equals(token.wrapped) || token1.wrapped.equals(token.wrapped);
}
function isSamePair(one, another) {
  return involvesToken(another, one.token0) && involvesToken(another, one.token1);
}
function getOutputToken(pair, inputToken) {
  return inputToken.wrapped.equals(pair.token0.wrapped) ? pair.token1 : pair.token0;
}
function isStableSwapPair(pair) {
  return !!pair.stableSwapAddress;
}

// evm/getStableSwapPairs.ts
import { CurrencyAmount as CurrencyAmount5 } from "@pancakeswap/sdk";

// ../token-lists/dist/chunk-YBVZDUCZ.mjs
import { Token } from "@pancakeswap/swap-sdk-core";
var WrappedTokenInfo = class extends Token {
  constructor(tokenInfo) {
    super(tokenInfo.chainId, tokenInfo.address, tokenInfo.decimals, tokenInfo.symbol, tokenInfo.name);
    this.logoURI = tokenInfo.logoURI;
  }
  get serialize() {
    return {
      address: this.address,
      chainId: this.chainId,
      decimals: this.decimals,
      symbol: this.symbol,
      name: this.name,
      projectLink: this.projectLink,
      logoURI: this.logoURI
    };
  }
};
function deserializeToken(serializedToken) {
  if (serializedToken.logoURI) {
    return new WrappedTokenInfo({
      chainId: serializedToken.chainId,
      address: serializedToken.address,
      decimals: serializedToken.decimals,
      symbol: serializedToken.symbol || "Unknown",
      name: serializedToken.name || "Unknown",
      logoURI: serializedToken.logoURI
    });
  }
  return new Token(
    serializedToken.chainId,
    serializedToken.address,
    serializedToken.decimals,
    serializedToken.symbol,
    serializedToken.name,
    serializedToken.projectLink
  );
}

// evm/getStableSwapPairs.ts
import fromPairs_ from "lodash/fromPairs";

// evm/stableSwap/getLPOutputWithoutFee.ts
import { Percent as Percent3 } from "@pancakeswap/sdk";

// evm/stableSwap/getLPOutput.ts
import { CurrencyAmount as CurrencyAmount2, JSBI as JSBI3, ZERO as ZERO2 } from "@pancakeswap/sdk";
import invariant3 from "tiny-invariant";

// evm/stableSwap/amm.ts
import { JSBI, ZERO, ONE } from "@pancakeswap/sdk";
import invariant from "tiny-invariant";
function getD({ amplifier, balances }) {
  const numOfCoins = balances.length;
  invariant(numOfCoins > 1, "To get constant D, pool should have at least two coins.");
  const sum = balances.reduce((s, cur) => JSBI.add(s, JSBI.BigInt(cur)), ZERO);
  if (JSBI.equal(sum, ZERO)) {
    return ZERO;
  }
  const n = JSBI.BigInt(numOfCoins);
  const precision = ONE;
  const ann = JSBI.multiply(JSBI.BigInt(amplifier), n);
  let dPrev = ZERO;
  let d = sum;
  for (let i = 0; i < 255; i += 1) {
    let dp = d;
    for (const b of balances) {
      dp = JSBI.divide(JSBI.multiply(dp, d), JSBI.add(JSBI.multiply(JSBI.BigInt(b), n), JSBI.BigInt(1)));
    }
    dPrev = d;
    d = JSBI.divide(
      JSBI.multiply(JSBI.add(JSBI.multiply(ann, sum), JSBI.multiply(dp, n)), d),
      JSBI.add(JSBI.multiply(JSBI.subtract(ann, ONE), d), JSBI.multiply(JSBI.add(n, ONE), dp))
    );
    if (JSBI.greaterThan(d, dPrev) && JSBI.lessThanOrEqual(JSBI.subtract(d, dPrev), precision)) {
      break;
    }
    if (JSBI.lessThanOrEqual(d, dPrev) && JSBI.lessThanOrEqual(JSBI.subtract(dPrev, d), precision)) {
      break;
    }
  }
  return d;
}
function getY({ amplifier, balances, i, j, x }) {
  const numOfCoins = balances.length;
  invariant(numOfCoins > 1, "To get y, pool should have at least two coins.");
  invariant(i !== j && i >= 0 && j >= 0 && i < numOfCoins && j < numOfCoins, `Invalid i: ${i} and j: ${j}`);
  const n = JSBI.BigInt(numOfCoins);
  const d = getD({ amplifier, balances });
  let sum = ZERO;
  let c = d;
  const ann = JSBI.multiply(JSBI.BigInt(amplifier), n);
  for (const [index, b2] of balances.entries()) {
    if (index === j) {
      continue;
    }
    let balanceAfterDeposit = JSBI.BigInt(b2);
    if (index === i) {
      balanceAfterDeposit = JSBI.add(balanceAfterDeposit, JSBI.BigInt(x));
    }
    sum = JSBI.add(sum, balanceAfterDeposit);
    c = JSBI.divide(JSBI.multiply(c, d), JSBI.multiply(balanceAfterDeposit, n));
  }
  c = JSBI.divide(JSBI.multiply(c, d), JSBI.multiply(ann, n));
  const b = JSBI.add(sum, JSBI.divide(d, ann));
  const precision = ONE;
  let yPrev = ZERO;
  let y = d;
  for (let k = 0; k < 255; k += 1) {
    yPrev = y;
    y = JSBI.divide(JSBI.add(JSBI.multiply(y, y), c), JSBI.subtract(JSBI.add(JSBI.multiply(JSBI.BigInt(2), y), b), d));
    if (JSBI.greaterThan(y, yPrev) && JSBI.lessThanOrEqual(JSBI.subtract(y, yPrev), precision)) {
      break;
    }
    if (JSBI.lessThanOrEqual(y, yPrev) && JSBI.lessThanOrEqual(JSBI.subtract(yPrev, y), precision)) {
      break;
    }
  }
  return y;
}

// evm/stableSwap/utils.ts
import { CurrencyAmount, ERC20Token, Percent, Price, JSBI as JSBI2 } from "@pancakeswap/sdk";
import invariant2 from "tiny-invariant";
function createStableSwapPair(pair, stableSwapAddress = "", lpAddress = "", infoStableSwapAddress = "", stableLpFee = 0, stableLpFeeRateOfTotalFee = 0) {
  return __spreadProps(__spreadValues({}, pair), {
    stableSwapAddress,
    lpAddress,
    infoStableSwapAddress,
    liquidityToken: new ERC20Token(pair.token0.chainId, lpAddress, 18, "Stable-LP", "Pancake StableSwap LPs"),
    // default price & fees are zero, need to get the actual price from chain
    price: new Price(pair.token0, pair.token1, "0", "1"),
    fee: new Percent(0),
    adminFee: new Percent(0),
    involvesToken: (token) => token.equals(pair.token0) || token.equals(pair.token1),
    stableLpFee,
    stableLpFeeRateOfTotalFee
  });
}
function createRouteWithStableSwap({
  routeType,
  input,
  pairs,
  output
}) {
  const wrappedInput = input.wrapped;
  const path = [wrappedInput];
  for (const [i, pair] of pairs.entries()) {
    const out = getOutputToken(pair, path[i]);
    path.push(out);
  }
  return {
    routeType,
    input,
    output,
    pairs,
    path
  };
}
function createTradeWithStableSwap({
  routeType,
  pairs,
  inputAmount,
  outputAmount,
  tradeType
}) {
  return {
    tradeType,
    inputAmount,
    outputAmount,
    route: createRouteWithStableSwap({
      routeType,
      pairs,
      input: inputAmount.currency,
      output: outputAmount.currency
    })
  };
}
function createTradeWithStableSwapFromV2Trade({
  tradeType,
  inputAmount,
  outputAmount,
  route: { pairs }
}) {
  return createTradeWithStableSwap({
    routeType: 0 /* V2 */,
    pairs,
    inputAmount,
    outputAmount,
    tradeType
  });
}
function getFeePercent(inputAmount, outputAmount, { fee, adminFee }) {
  invariant2(fee.currency.equals(outputAmount.currency), "FEE_CURRENCY_MATCH");
  invariant2(adminFee.currency.equals(outputAmount.currency), "FEE_CURRENCY_MATCH");
  const priceWithoutFee = new Price({ baseAmount: outputAmount.add(fee), quoteAmount: inputAmount });
  const inputFee = priceWithoutFee.quote(fee);
  const inputAdminFee = priceWithoutFee.quote(adminFee);
  return {
    fee: new Percent(inputFee.quotient, inputAmount.quotient),
    adminFee: new Percent(inputAdminFee.quotient, inputAmount.quotient)
  };
}
var PRECISION = JSBI2.exponentiate(JSBI2.BigInt(10), JSBI2.BigInt(18));
var getRawAmount = (amount) => {
  return JSBI2.divide(
    JSBI2.multiply(amount.quotient, PRECISION),
    JSBI2.exponentiate(JSBI2.BigInt(10), JSBI2.BigInt(amount.currency.decimals))
  );
};
var parseAmount = (currency, rawAmount) => {
  return CurrencyAmount.fromRawAmount(
    currency,
    JSBI2.divide(
      JSBI2.multiply(rawAmount, JSBI2.exponentiate(JSBI2.BigInt(10), JSBI2.BigInt(currency.decimals))),
      PRECISION
    )
  );
};

// evm/stableSwap/getLPOutput.ts
function getLPOutput({
  amplifier,
  balances,
  totalSupply,
  amounts,
  fee
}) {
  const lpToken = totalSupply.currency;
  const lpTotalSupply = totalSupply.quotient;
  if (JSBI3.equal(lpTotalSupply, ZERO2) || !balances.length || balances.every((b) => JSBI3.equal(b.quotient, ZERO2))) {
    const d = getD({ amplifier, balances: amounts.map(getRawAmount) });
    return CurrencyAmount2.fromRawAmount(lpToken, d);
  }
  const currentBalances = [];
  const newBalances = [];
  for (const [i, balance] of balances.entries()) {
    const amount = amounts[i] || CurrencyAmount2.fromRawAmount(balance.currency, 0);
    invariant3(
      amount.currency.wrapped.equals(balance.currency.wrapped),
      "User input currency should be the same as pool balance currency."
    );
    const balanceRaw = getRawAmount(balance);
    const amountRaw = getRawAmount(amount);
    currentBalances.push(balanceRaw);
    newBalances.push(JSBI3.add(balanceRaw, amountRaw));
  }
  const d0 = getD({ amplifier, balances: currentBalances });
  const d1 = getD({ amplifier, balances: newBalances });
  invariant3(JSBI3.greaterThanOrEqual(d1, d0), "D1 should be greater than or equal than d0.");
  const isFirstSupply = JSBI3.lessThanOrEqual(lpTotalSupply, ZERO2);
  if (isFirstSupply) {
    return CurrencyAmount2.fromRawAmount(totalSupply.currency, d1);
  }
  const n = currentBalances.length;
  const eachTokenFee = fee.multiply(n).divide(4 * (n - 1));
  let d2 = d1;
  for (const [i, b] of currentBalances.entries()) {
    const idealBalance = JSBI3.divide(JSBI3.multiply(d1, b), d0);
    let diff = ZERO2;
    if (JSBI3.greaterThan(idealBalance, newBalances[i])) {
      diff = JSBI3.subtract(idealBalance, newBalances[i]);
    } else {
      diff = JSBI3.subtract(newBalances[i], idealBalance);
    }
    const feeAmount = eachTokenFee.multiply(diff).quotient;
    newBalances[i] = JSBI3.subtract(newBalances[i], feeAmount);
  }
  d2 = getD({ amplifier, balances: newBalances });
  const expectedMintLP = JSBI3.divide(JSBI3.multiply(lpTotalSupply, JSBI3.subtract(d2, d0)), d0);
  return CurrencyAmount2.fromRawAmount(totalSupply.currency, expectedMintLP);
}

// evm/stableSwap/getLPOutputWithoutFee.ts
function getLPOutputWithoutFee(params) {
  return getLPOutput(__spreadProps(__spreadValues({}, params), { fee: new Percent3(0) }));
}

// evm/stableSwap/getSwapOutput.ts
import { CurrencyAmount as CurrencyAmount4, JSBI as JSBI4, Percent as Percent4, ZERO as ZERO3, ONE_HUNDRED_PERCENT } from "@pancakeswap/sdk";
import invariant4 from "tiny-invariant";
function getSwapOutput({
  amplifier,
  balances: balanceAmounts,
  outputCurrency,
  amount,
  fee
}) {
  let i = null;
  let j = null;
  const balances = [];
  for (const [index, b] of balanceAmounts.entries()) {
    balances.push(getRawAmount(b));
    if (b.currency.wrapped.equals(amount.currency.wrapped)) {
      i = index;
      continue;
    }
    if (b.currency.wrapped.equals(outputCurrency.wrapped)) {
      j = index;
      continue;
    }
  }
  invariant4(
    i !== null && j !== null && i !== j,
    "Input currency or output currency does not match currencies of token balances."
  );
  if (JSBI4.lessThan(amount.quotient, ZERO3)) {
    const x = ONE_HUNDRED_PERCENT.subtract(fee).invert().multiply(getRawAmount(amount)).quotient;
    const y2 = getY({ amplifier, balances, i, j, x });
    const dy2 = JSBI4.subtract(y2, balances[j]);
    return parseAmount(outputCurrency, dy2);
  }
  const y = getY({ amplifier, balances, i, j, x: getRawAmount(amount) });
  const dy = JSBI4.subtract(balances[j], y);
  const feeAmount = fee.multiply(dy).quotient;
  return parseAmount(outputCurrency, JSBI4.subtract(dy, feeAmount));
}
function getSwapOutputWithoutFee(params) {
  return getSwapOutput(__spreadProps(__spreadValues({}, params), { fee: new Percent4(0) }));
}

// evm/stableSwap/index.ts
var StableSwap = {
  getSwapOutput,
  getSwapOutputWithoutFee,
  getLPOutputWithoutFee,
  getLPOutput,
  getD
};

// evm/constants/stableSwap/pools.ts
import { ChainId as ChainId4 } from "@pancakeswap/sdk";

// evm/constants/stableSwap/137.ts
var pools = [
  //   {
  //     lpSymbol: 'HAY-BUSD LP',
  //     lpAddress: '0xB6040A9F294477dDAdf5543a24E5463B8F2423Ae',
  //     token: bscTokens.hay,
  //     quoteToken: bscTokens.busd,
  //     stableSwapAddress: '0x49079d07ef47449af808a4f36c2a8dec975594ec',
  //     infoStableSwapAddress: '0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6',
  //     stableLpFee: 0.0002,
  //     stableLpFeeRateOfTotalFee: 0.5,
  //   },
  // {
  //   lpSymbol: 'USDT-BUSD LP',
  //   lpAddress: '0x36842F8fb99D55477C0Da638aF5ceb6bBf86aA98',
  //   token: bscTokens.usdt,
  //   quoteToken: bscTokens.busd,
  //   stableSwapAddress: '0x169F653A54ACD441aB34B73dA9946e2C451787EF',
  //   infoStableSwapAddress: '0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6',
  //   stableLpFee: 0.00005,
  //   stableLpFeeRateOfTotalFee: 0.5,
  // },
  // {
  //   lpSymbol: 'USDC-BUSD LP',
  //   lpAddress: '0x1A77C359D0019cD8F4d36b7CDf5a88043D801072',
  //   token: bscTokens.usdc,
  //   quoteToken: bscTokens.busd,
  //   stableSwapAddress: '0xc2F5B9a3d9138ab2B74d581fC11346219eBf43Fe',
  //   infoStableSwapAddress: '0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6',
  //   stableLpFee: 0.00005,
  //   stableLpFeeRateOfTotalFee: 0.5,
  // },
  // {
  //   lpSymbol: 'USDT-USDC LP',
  //   lpAddress: '0xee1bcc9F1692E81A281b3a302a4b67890BA4be76',
  //   token: bscTokens.usdt,
  //   quoteToken: bscTokens.usdc,
  //   stableSwapAddress: '0x3EFebC418efB585248A0D2140cfb87aFcc2C63DD',
  //   infoStableSwapAddress: '0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6',
  //   stableLpFee: 0.00005,
  //   stableLpFeeRateOfTotalFee: 0.5,
  // },
  // {
  //   lpSymbol: 'axlUSDC-USDT LP',
  //   lpAddress: '0x1c7e5a3A72b6D94DE5Ec20812E3e68713978a584',
  //   token: bscTokens.axlusdc,
  //   quoteToken: bscTokens.usdt,
  //   stableSwapAddress: '0x6D8fba276ec6F1EDa2344DA48565AdbCA7e4FFa5',
  //   infoStableSwapAddress: '0x150c8AbEB487137acCC541925408e73b92F39A50',
  //   stableLpFee: 0.0002,
  //   stableLpFeeRateOfTotalFee: 0.5,
  // },
  //   {
  //     lpSymbol: 'WBNB-stkBNB LP',
  //     lpAddress: '0x9976f5c8BEfDee650226d5571d5F5551e8722b75',
  //     token: bscTokens.wbnb,
  //     quoteToken: bscTokens.stkbnb,
  //     stableSwapAddress: '0x0b03e3d6Ec0c5e5bBf993dED8D947C6fb6eEc18D',
  //     infoStableSwapAddress: '0x150c8AbEB487137acCC541925408e73b92F39A50',
  //     stableLpFee: 0.0002,
  //     stableLpFeeRateOfTotalFee: 0.5,
  //   },
  //   {
  //     lpSymbol: 'BNBx-BNB LP',
  //     lpAddress: '0x92357Ab9003CA881E08e32CDAE59B10B3161b05C',
  //     token: bscTokens.bnbx,
  //     quoteToken: bscTokens.wbnb,
  //     stableSwapAddress: '0x9c138bE1D76ee4C5162E0fe9D4eEA5542a23D1bD',
  //     infoStableSwapAddress: '0x150c8AbEB487137acCC541925408e73b92F39A50',
  //     stableLpFee: 0.0002,
  //     stableLpFeeRateOfTotalFee: 0.5,
  //   },
];

// ../tokens/src/common.ts
import { ChainId, ERC20Token as ERC20Token2 } from "@pancakeswap/sdk";
var CAKE_MAINNET = new ERC20Token2(
  ChainId.BSC,
  "0x328801B0b580eAdd83eA841638865eA41Dc6fb25",
  18,
  "PLAX",
  "Plaxswap Token",
  "https://www.plaxswap.io/"
);
var CAKE_TESTNET = new ERC20Token2(
  ChainId.BSC_TESTNET,
  "0xFa60D973F7642B748046464e165A65B7323b0DEE",
  18,
  "CAKE",
  "PancakeSwap Token",
  "https://pancakeswap.finance/"
);
var USDC_BSC = new ERC20Token2(
  ChainId.BSC,
  "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
  6,
  "USDC",
  "USD Coin"
);
var USDC_TESTNET = new ERC20Token2(
  ChainId.BSC_TESTNET,
  "0x64544969ed7EBf5f083679233325356EbE738930",
  18,
  "USDC",
  "Binance-Peg USD Coin",
  "https://www.centre.io/usdc"
);
var USDC_ETH = new ERC20Token2(
  ChainId.ETHEREUM,
  "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  6,
  "USDC",
  "USD Coin"
);
var USDC_GOERLI = new ERC20Token2(
  ChainId.GOERLI,
  "0x07865c6E87B9F70255377e024ace6630C1Eaa37F",
  6,
  "tUSDC",
  "test USD Coin"
);
var USDT_BSC = new ERC20Token2(
  ChainId.BSC,
  "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
  6,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var USDT_ETH = new ERC20Token2(
  ChainId.ETHEREUM,
  "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  6,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BSC = new ERC20Token2(
  ChainId.BSC,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.binance/en/busd"
);
var BUSD_TESTNET = new ERC20Token2(
  ChainId.BSC_TESTNET,
  "0xaB1a4d4f1D656d2450692D237fdD6C7f9146e814",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var BUSD_ETH = new ERC20Token2(
  ChainId.ETHEREUM,
  "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var BUSD_GOERLI = new ERC20Token2(
  ChainId.GOERLI,
  "0xb809b9B2dc5e93CB863176Ea2D565425B03c0540",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var BUSD = {
  [ChainId.ETHEREUM]: BUSD_ETH,
  [ChainId.GOERLI]: BUSD_GOERLI,
  [ChainId.BSC]: BUSD_BSC,
  [ChainId.BSC_TESTNET]: BUSD_TESTNET
};
var CAKE = {
  [ChainId.BSC]: CAKE_MAINNET,
  [ChainId.BSC_TESTNET]: CAKE_TESTNET
};
var USDC = {
  [ChainId.ETHEREUM]: USDC_ETH,
  [ChainId.GOERLI]: USDC_GOERLI,
  [ChainId.BSC]: USDC_BSC,
  [ChainId.BSC_TESTNET]: USDC_TESTNET
};
var USDT = {
  [ChainId.ETHEREUM]: USDT_ETH,
  [ChainId.BSC]: USDT_BSC
};
var WBTC_ETH = new ERC20Token2(
  ChainId.ETHEREUM,
  "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  8,
  "WBTC",
  "Wrapped BTC"
);

// ../tokens/src/137.ts
import { ChainId as ChainId2, WBNB, ERC20Token as ERC20Token3 } from "@pancakeswap/sdk";
var bscTokens = {
  wbnb: WBNB[ChainId2.BSC],
  // bnb here points to the wbnb contract. Wherever the currency BNB is required, conditional checks for the symbol 'BNB' can be used
  bnb: new ERC20Token3(
    ChainId2.BSC,
    "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    18,
    "POL",
    "Polygon Ecosystem Token",
    "https://polygon.technology/"
  ),
  cake: CAKE_MAINNET,
  busd: BUSD_BSC,
  dai: new ERC20Token3(
    ChainId2.BSC,
    "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
    18,
    "DAI",
    "Dai Stablecoin",
    "https://www.makerdao.com/"
  ),
  usdt: USDT_BSC,
  btcb: new ERC20Token3(
    ChainId2.BSC,
    "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
    18,
    "BTCB",
    "Binance BTC",
    "https://bitcoin.org/"
  ),
  sfund: new ERC20Token3(
    ChainId2.BSC,
    "0x477bC8d23c634C154061869478bce96BE6045D12",
    18,
    "SFUND",
    "Seedify Fund Token",
    "https://seedify.fund/"
  ),
  snfts: new ERC20Token3(
    ChainId2.BSC,
    "0x6f51A1674BEFDD77f7ab1246b83AdB9f13613762",
    18,
    "SNFTS",
    "Seedify NFT Space",
    "https://snfts.seedify.fund/"
  ),
  sd: new ERC20Token3(
    ChainId2.BSC,
    "0x1d734A02eF1e1f5886e66b0673b71Af5B53ffA94",
    18,
    "SD",
    "Stader (PoS)",
    "https://www.staderlabs.com/"
  ),
  usdc: USDC_BSC,
  syrup: new ERC20Token3(
    ChainId2.BSC,
    "0x7cbbC91c05c64c5E5b12Da6F090F8f11480deA64",
    18,
    "PLAXBAR",
    "PlasaBar Token",
    "https://pancakeswap.finance/"
  ),
  axlusdc: new ERC20Token3(
    ChainId2.BSC,
    "0x750e4C4984a9e0f12978eA6742Bc1c5D248f40ed",
    6,
    "axlUSDC",
    "Axelar Wrapped USDC",
    "https://axelarscan.io/assets/"
  ),
  lazio: new ERC20Token3(
    ChainId2.BSC,
    "0x77d547256A2cD95F32F67aE0313E450Ac200648d",
    8,
    "LAZIO",
    "FC Lazio Fan Token",
    "https://launchpad.binance.com/en/subscription/LAZIO_BNB"
  ),
  porto: new ERC20Token3(
    ChainId2.BSC,
    "0x49f2145d6366099e13B10FbF80646C0F377eE7f6",
    8,
    "PORTO",
    "FC Porto Fan Token",
    "https://launchpad.binance.com/en/subscription/PORTO_BNB"
  ),
  santos: new ERC20Token3(
    ChainId2.BSC,
    "0xA64455a4553C9034236734FadDAddbb64aCE4Cc7",
    8,
    "SANTOS",
    "FC Santos Fan Token",
    "https://launchpad.binance.com/en/launchpool/SANTOS_BNB"
  ),
  mbox: new ERC20Token3(
    ChainId2.BSC,
    "0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377",
    18,
    "MBOX",
    "Mobox Token",
    "https://www.mobox.io/#/"
  ),
  dar: new ERC20Token3(
    ChainId2.BSC,
    "0x23CE9e926048273eF83be0A3A8Ba9Cb6D45cd978",
    6,
    "DAR",
    "Mines of Dalarnia",
    "https://www.minesofdalarnia.com/"
  ),
  pay: new ERC20Token3(
    ChainId2.BSC,
    "0x7Ab2b041E120DcA2a40d8F9524B618A854d3A617",
    8,
    "PAY",
    "PLAXPAY",
    "https://www.plaxpay.app/"
  ),
  tpay: new ERC20Token3(
    ChainId2.BSC,
    "0x8DF4c954C51E5ccBa51b8a21cC3fF6347760b31a",
    18,
    "TPAY",
    "PAYMATIC",
    "https://www.paymatic.cloud/"
  ),
  sme: new ERC20Token3(
    ChainId2.BSC,
    "0xcD9c386c9CE5987A8336C4Db5c6A17750ea0e339",
    8,
    "SME",
    "WESMEUP",
    "https://www.wesmeup.net/"
  ),
  idrt: new ERC20Token3(
    ChainId2.BSC,
    "0x554cd6bdD03214b10AafA3e0D4D42De0C5D2937b",
    6,
    "IDRT",
    "RUPIAH TOKEN",
    "https://rupiahtoken.com"
  ),
  idrx: new ERC20Token3(
    ChainId2.BSC,
    "0x649a2DA7B28E0D54c13D5eFf95d3A660652742cC",
    0,
    "IDRX",
    "IDRX",
    "https://idrx.co"
  ),
  xidr: new ERC20Token3(
    ChainId2.BSC,
    "0x2c826035c1C36986117A0e949bD6ad4baB54afE2",
    6,
    "XIDR",
    "XIDR",
    "https://www.straitsx.com/id/xidr"
  ),
  xsgd: new ERC20Token3(
    ChainId2.BSC,
    "0xDC3326e71D45186F113a2F448984CA0e8D201995",
    6,
    "XSGD",
    "XSGD",
    "https://www.straitsx.com/id/xsgd"
  ),
  quick: new ERC20Token3(
    ChainId2.BSC,
    "0xB5C064F955D8e7F38fE0460C556a72987494eE17",
    18,
    "QUICK",
    "QUICKSWAP",
    "https://quickswap.exchange"
  ),
  aave: new ERC20Token3(
    ChainId2.BSC,
    "0xD6DF932A45C0f255f85145f286eA0b292B21C90B",
    18,
    "AAVE",
    "AAVE",
    "https://aave.com"
  ),
  df: new ERC20Token3(
    ChainId2.BSC,
    "0x08C15FA26E519A78a666D19CE5C646D55047e0a3",
    18,
    "DF",
    "DFORCE",
    "https://dforce.network/"
  ),
  usx: new ERC20Token3(
    ChainId2.BSC,
    "0xCf66EB3D546F0415b368d98A95EAF56DeD7aA752",
    18,
    "USX",
    "DFORCE USD",
    "https://dforce.network/"
  ),
  uni: new ERC20Token3(
    ChainId2.BSC,
    "0xb33EaAd8d922B1083446DC23f610c2567fB5180f",
    18,
    "UNI",
    "UNISWAP",
    "https://app.uniswap.org/"
  ),
  knc: new ERC20Token3(
    ChainId2.BSC,
    "0x1C954E8fe737F99f68Fa1CCda3e51ebDB291948C",
    18,
    "KNC",
    "KYBER NETWORK CRYSTAL",
    "https://kyber.network"
  ),
  crv: new ERC20Token3(
    ChainId2.BSC,
    "0x172370d5Cd63279eFa6d502DAB29171933a610AF",
    18,
    "CRV",
    "CURVE DAO",
    "https://www.curve.fi/"
  ),
  rr: new ERC20Token3(
    ChainId2.BSC,
    "0x91Faa9fA243EaF35981f5563ec67e9bF0d8DFAEE",
    18,
    "RR",
    "RFIDR",
    "https://www.rfidr.net/"
  ),
  rfm: new ERC20Token3(
    ChainId2.BSC,
    "0x04488963B02447B1ba926DBa6AD3a5f57fD855f1",
    18,
    "RFM",
    "RFIDM",
    "https://www.rfidr.net/"
  ),
  rfc: new ERC20Token3(
    ChainId2.BSC,
    "0x9947d87c811e6033A1eEAFf3D25f6b4A94A8A1a7",
    18,
    "RFC",
    "RFIDC",
    "https://www.rfidr.net/"
  ),
  rfx: new ERC20Token3(
    ChainId2.BSC,
    "0x8439cc930D330427D8A4BBABC335F5927A52fa87",
    18,
    "RFX",
    "RFIDX",
    "https://www.rfidr.net/"
  ),
  fif: new ERC20Token3(
    ChainId2.BSC,
    "0xbaEF7137D3cEC6282a83dd954eA6376d464f7780",
    18,
    "FIF",
    "FREEDOM INITIAL FUND",
    "https://freetech.site"
  ),
  bcore: new ERC20Token3(
    ChainId2.BSC,
    "0xA830a38CeAC7BFe3568D229945A45121730fbb91",
    18,
    "BCORE",
    "Bulldog Core",
    "https://www.bullclub.site/"
  ),
  brc: new ERC20Token3(
    ChainId2.BSC,
    "0x580b956f9828225647C154E13569A2409e0AAd27",
    18,
    "BRC",
    "Bulldog Racing Club",
    "https://fairlaunch.cloud/bullclub/?refId=0x178A29F79eD22f9cc4fE1FAB1Dc9c095dC58d844/"
  ),
  burn: new ERC20Token3(
    ChainId2.BSC,
    "0xF84F0C7D675728D7fadD0D9dd97AbE26EB14642c",
    18,
    "BURN",
    "BULLDOG REBORN",
    "https://www.bullclub.site/"
  ),
  ball: new ERC20Token3(
    ChainId2.BSC,
    "0xCC135a9d941d2a1f40d55a04eb6A90d9835dA7d7",
    18,
    "BALL",
    "BULLDOG ALLIANCE",
    "https://www.bullclub.site/"
  ),
  brand: new ERC20Token3(
    ChainId2.BSC,
    "0xb0de690CA7C204608062765507e280d0163D452C",
    18,
    "BRAND",
    "BULLDOG BRAND",
    "https://www.bullclub.site/"
  ),
  wbtc: new ERC20Token3(
    ChainId2.BSC,
    "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
    8,
    "WBTC",
    "Wrapped BTC",
    "https://www.wbtc.network/"
  ),
  weth: new ERC20Token3(
    ChainId2.BSC,
    "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
    18,
    "wETH",
    "Wrapped Ether",
    "https://ethereum.org/"
  ),
  sol: new ERC20Token3(
    ChainId2.BSC,
    "0xd93f7E271cB87c23AaA73edC008A79646d1F9912",
    9,
    "SOL",
    "SOLANA",
    "https://solana.com/"
  ),
  inch: new ERC20Token3(
    ChainId2.BSC,
    "0x9c2C5fd7b07E95EE044DDeba0E97a665F142394f",
    18,
    "1INCH",
    "1INCH",
    "https://1inch.io/"
  ),
  shib: new ERC20Token3(
    ChainId2.BSC,
    "0x6f8a06447Ff6FcF75d803135a7de15CE88C1d4ec",
    18,
    "SHIB",
    "SHIBA INU",
    "https://shibatoken.com/"
  ),
  bonk: new ERC20Token3(
    ChainId2.BSC,
    "0xe5B49820e5A1063F6F4DdF851327b5E8B2301048",
    5,
    "BONK",
    "BONK",
    "https://bonkcoin.com/"
  ),
  cro: new ERC20Token3(
    ChainId2.BSC,
    "0xAdA58DF0F643D959C2A47c9D4d4c1a4deFe3F11C",
    8,
    "CRO",
    "CRONOS",
    "https://cronos-pos.org/"
  ),
  woo: new ERC20Token3(
    ChainId2.BSC,
    "0x1B815d120B3eF02039Ee11dC2d33DE7aA4a8C603",
    18,
    "WOO",
    "WOO",
    "https://woo.org/"
  ),
  elon: new ERC20Token3(
    ChainId2.BSC,
    "0xE0339c80fFDE91F3e20494Df88d4206D86024cdF",
    18,
    "ELON",
    "Dogelon Mars",
    "https://dogelonmars.com/"
  ),
  aro: new ERC20Token3(
    ChainId2.BSC,
    "0xa7D3aA3206425EeC18D9C8bC7A8b7ee922666bdF",
    18,
    "ARO",
    "AroLiex",
    "https://aroliex.co/"
  ),
  pps: new ERC20Token3(
    ChainId2.BSC,
    "0x5e4d5A1C3470d38b030af2AeA2ADA046Fc34cac6",
    18,
    "PPS",
    "Private Pool Share",
    "https://polygonscan.com/token/0x5e4d5a1c3470d38b030af2aea2ada046fc34cac6#code"
  ),
  zap: new ERC20Token3(
    ChainId2.BSC,
    "0x6b7682a9fdA1d482A3779C9489DC62437BB58945",
    18,
    "ZAP",
    "ZELTSPHY",
    "https://polygonscan.com/token/0x6b7682a9fdA1d482A3779C9489DC62437BB58945#code"
  ),
  aura: new ERC20Token3(
    ChainId2.BSC,
    "0x2a12ffDb78Ad627F1a78cA96964eef58b36Dc9c8",
    18,
    "AURA",
    "AZZURAZZA",
    "https://polygonscan.com/token/0x2a12ffDb78Ad627F1a78cA96964eef58b36Dc9c8#code"
  ),
  bcatt: new ERC20Token3(
    ChainId2.BSC,
    "0x4A780Bb9D55173426f77D494aA8645273653924E",
    18,
    "BCATT",
    "Boss Cat",
    "https://www.bcatt.fun/"
  ),
  daz: new ERC20Token3(
    ChainId2.BSC,
    "0xB5f6ca3CDC4d42A57eF85f22Ca98AD4D222D7F4E",
    18,
    "DAZ",
    "BITZAURA",
    "https://www.bitzaura.org/"
  ),
  dax: new ERC20Token3(
    ChainId2.BSC,
    "0x78Dcb158C18cFF931D188Fe179128e5A8068aE8d",
    18,
    "DAX",
    "BITZAURA-X",
    "https://www.bitzaura.org/"
  ),
  dca: new ERC20Token3(
    ChainId2.BSC,
    "0xD079128bb5D552E5AA310e252aF535cF0572943D",
    18,
    "DCA",
    "BITZAURA CAMP",
    "https://www.bitzaura.org/"
  ),
  dass: new ERC20Token3(
    ChainId2.BSC,
    "0xda432286FEd68F40f5aF28F1E005b2378146B8Cc",
    18,
    "DASS",
    "BitZaura Association",
    "https://www.bitzaura.org/"
  ),
  dgold: new ERC20Token3(
    ChainId2.BSC,
    "0x7aE71763B5Cc70BA3932D05352Da3Af591ed4fEa",
    18,
    "DGOLD",
    "BitZaura Gold",
    "https://www.bitzaura.org/"
  ),
  paxg: new ERC20Token3(
    ChainId2.BSC,
    "0x553d3D295e0f695B9228246232eDF400ed3560B5",
    18,
    "PAXG",
    "PAX Gold",
    "https://paxos.com/paxgold/"
  ),
  cpoin: new ERC20Token3(
    ChainId2.BSC,
    "0x37aDC8f969b63B8bBD025D10D03900C5cd9DD367",
    0,
    "CPOIN",
    "CLABS REWARD",
    "https://www.cpoin.net/"
  ),
  cpoinx: new ERC20Token3(
    ChainId2.BSC,
    "0xE7A3eEDDd6c4F339D4219aFBAE5605CA3DF9DDD1",
    18,
    "CPOIN-X",
    "CLABS POOL",
    "https://www.cpoin.net/"
  ),
  btf: new ERC20Token3(
    ChainId2.BSC,
    "0x9b3d2aFc6fDfeF566a224E2786bAfC854fAf6800",
    18,
    "BTF",
    "Bitfind",
    "https://bitfind.co"
  ),
  ctf: new ERC20Token3(
    ChainId2.BSC,
    "0x2eB8556dB957a0C9394cedE2f5B11064824Dd060",
    0,
    "CTF",
    "CrowdTech Fund",
    "https://bitfind.vip"
  ),
  btfc: new ERC20Token3(
    ChainId2.BSC,
    "0x2721098562f5b3dc79917730C2646877F5F374F9",
    18,
    "BTFC",
    "Bitfind Camp",
    "https://bitfind.vip"
  ),
  dapps: new ERC20Token3(
    ChainId2.BSC,
    "0xC8C16304f6B722F910fb3A74bee55F7F4Dfd36dF",
    18,
    "DAPPS",
    "Defi Project",
    "https://bitfind.vip"
  ),
  rsi: new ERC20Token3(
    ChainId2.BSC,
    "0x467C3603BEE6F43e9497afA93720d55586213dFE",
    18,
    "RSI",
    "Real Project Finance",
    "https://bitfind.vip"
  ),
  btgs: new ERC20Token3(
    ChainId2.BSC,
    "0x230f5A4dC8A12698bC65373a47061A50C270D343",
    18,
    "BTGS",
    "BitGands",
    "https://bitfind.co"
  ),
  btps: new ERC20Token3(
    ChainId2.BSC,
    "0xCcdc94871f1945F8eE75369e14E7D7f7edD371A7",
    18,
    "BTPS",
    "BitParts",
    "https://bitfind.co"
  ),
  plaxusdt: new ERC20Token3(
    ChainId2.BSC,
    "0x8ae534F07f08422d00Ed00a2Be1335e411Fb9DA0",
    18,
    "PLAXusdt",
    "PLAX-USDT LP",
    "https://plaxswaap.io"
  ),
  payusdt: new ERC20Token3(
    ChainId2.BSC,
    "0x7Fa11bb242CbBa853f634BEF02Fc24A3A13f916d",
    18,
    "PAYusdt",
    "PAY-USDT LP",
    "https://www.plaxpay.app/"
  ),
  smeusdt: new ERC20Token3(
    ChainId2.BSC,
    "0xB4C4Cd512d60F0E589fBcC58353C1e6225f9a1BB",
    18,
    "SMEusdt",
    "SME-USDT LP",
    "https://www.wesmeup.net/"
  ),
  doa: new ERC20Token3(
    ChainId2.BSC,
    "0x058E73a591FF67ed31D92679db27950eb2546ca1",
    18,
    "DOA",
    "ALIRI",
    "https://aliri.org/"
  ),
  alifi: new ERC20Token3(
    ChainId2.BSC,
    "0x38e009e25A3B6459345e9c07B93ea41E05AC0990",
    18,
    "ALIFI",
    "ALIRI FINANCE",
    "https://aliri.vip/"
  ),
  alicia: new ERC20Token3(
    ChainId2.BSC,
    "0x1B6e0561f053830e34349111af458Dc130937928",
    18,
    "ALICIA",
    "ALIRI CREATIVE INDUSTRY",
    "https://aliri.vip/"
  ),
  farm: new ERC20Token3(
    ChainId2.BSC,
    "0x4490d8Dca8a1dbD10c084bFe8EA286c7fa62373A",
    18,
    "FARM",
    "FREEDOM AUTO REVSHARE",
    "https://freetech.site"
  ),
  face: new ERC20Token3(
    ChainId2.BSC,
    "0xe9716d7D7248ad22Ac94Fb36DC28Bbbf45E11958",
    18,
    "FACE",
    "FREEDOM CROWDFUNDING EXPERT",
    "https://freetech.site"
  ),
  fgold: new ERC20Token3(
    ChainId2.BSC,
    "0x38A33Cf60164EaC333400aB0ee7DeeBe92f968dB",
    18,
    "FGOLD",
    "FREEGOLD",
    "https://polygonscan.com/token/0x38A33Cf60164EaC333400aB0ee7DeeBe92f968dB"
  ),
  gidr: new ERC20Token3(
    ChainId2.BSC,
    "0x0a40ff165736f5989e9F40fFbEd24A640c760754",
    18,
    "GIDR",
    "Gold Indonesia Republic",
    "https://gidr.co.id/"
  ),
  clk: new ERC20Token3(
    ChainId2.BSC,
    "0x1EdC86d411AD224f97b6Ad89C4446683C1b0BAaE",
    8,
    "CLK",
    "COINLUCK",
    "https://coinluck.biz/"
  ),
  tba: new ERC20Token3(
    ChainId2.BSC,
    "0x25481b64c8733475fD17C57e24082Ef938cc40D5",
    18,
    "TBA",
    "THUBA",
    "https://coinluck.biz/"
  ),
  rca: new ERC20Token3(
    ChainId2.BSC,
    "0x4042bA2085eDfA4b68106b2eec5d5007F1D36DdE",
    18,
    "RCA",
    "RECOIN ASSET",
    "https://recoins.org/"
  ),
  rcr: new ERC20Token3(
    ChainId2.BSC,
    "0xfB70D564b875A9745a956E135D69e70B59C3905B",
    18,
    "RCR",
    "RECOIN RENT",
    "https://recoins.org/"
  ),
  vindex: new ERC20Token3(
    ChainId2.BSC,
    "0x9cE83AECC84836d3a95E63a48664Eb82a369960b",
    18,
    "VINDEX",
    "VINDEX",
    "https://polygonscan.com/token/0x9cE83AECC84836d3a95E63a48664Eb82a369960b#code"
  ),
  vreedex: new ERC20Token3(
    ChainId2.BSC,
    "0x931ea97a2E2baB7571CE9C1B6b8148a53f8997bD",
    18,
    "VREEDEX",
    "VREEDEX",
    "https://polygonscan.com/token/0x931ea97a2E2baB7571CE9C1B6b8148a53f8997bD#code"
  ),
  yuhuu: new ERC20Token3(
    ChainId2.BSC,
    "0x613B617dBb9fC94Bc13febf7113AE8fa1C678cE1",
    18,
    "YUHUU",
    "YUHUU",
    "https://polygonscan.com/token/0x613B617dBb9fC94Bc13febf7113AE8fa1C678cE1#code"
  ),
  list: new ERC20Token3(
    ChainId2.BSC,
    "0x9ffAEb136E3793B5B9D1E3a49012D55D22E7Fa3f",
    18,
    "LIST",
    "LIQUD STAKE",
    "https://liquidstake.net"
  )
};

// ../tokens/src/80001.ts
import { ChainId as ChainId3, ERC20Token as ERC20Token4, WBNB as WBNB2 } from "@pancakeswap/sdk";
var bscTestnetTokens = {
  wbnb: WBNB2[ChainId3.BSC_TESTNET],
  cake: CAKE_TESTNET,
  busd: BUSD_TESTNET,
  syrup: new ERC20Token4(
    ChainId3.BSC_TESTNET,
    "0xfE1e507CeB712BDe086f3579d2c03248b2dB77f9",
    18,
    "SYRUP",
    "SyrupBar Token",
    "https://pancakeswap.finance/"
  ),
  bake: new ERC20Token4(
    ChainId3.BSC_TESTNET,
    "0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5",
    18,
    "BAKE",
    "Bakeryswap Token",
    "https://www.bakeryswap.org/"
  ),
  hbtc: new ERC20Token4(ChainId3.BSC_TESTNET, "0x3Fb6a6C06c7486BD194BB99a078B89B9ECaF4c82", 18, "HBTC", "Huobi BTC"),
  wbtc: new ERC20Token4(ChainId3.BSC_TESTNET, "0xfC8bFbe9644e1BC836b8821660593e7de711e564", 8, "WBTC", "Wrapped BTC"),
  usdc: new ERC20Token4(
    ChainId3.BSC_TESTNET,
    "0xCA8eB2dec4Fe3a5abbFDc017dE48E461A936623D",
    18,
    "USDC",
    "Binance-Peg USD Coin"
  ),
  usdt: new ERC20Token4(ChainId3.BSC_TESTNET, "0x0fB5D7c73FA349A90392f873a4FA1eCf6a3d0a96", 18, "USDT", "Tether USD"),
  mockBusd: new ERC20Token4(
    ChainId3.BSC_TESTNET,
    "0x3304dd20f6Fe094Cb0134a6c8ae07EcE26c7b6A7",
    18,
    "BUSD",
    "Binance USD"
  )
};

// evm/constants/stableSwap/80001.ts
var pools2 = [
  {
    lpSymbol: "USDC-BUSD LP",
    lpAddress: "0xd1742b5eC6798cEB8C791e0ebbEf606A4946f67E",
    token: bscTestnetTokens.usdc,
    // coins[0]
    quoteToken: bscTestnetTokens.busd,
    // coins[1]
    stableSwapAddress: "0x1288026D2c5a76A5bfb0730F615131A448f4Ad06",
    infoStableSwapAddress: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
    stableLpFee: 0,
    stableLpFeeRateOfTotalFee: 0
  },
  {
    lpSymbol: "WBNB-USDT LP",
    lpAddress: "0x13Ea1BA0DE82aad338D0f7CE3F4eE505280f1B92",
    token: bscTestnetTokens.usdt,
    // coins[0]
    quoteToken: bscTestnetTokens.wbnb,
    // coins[1]
    stableSwapAddress: "0xD38F21E8C575F85Ef3dFeeCfb177666aA62DEcd2",
    infoStableSwapAddress: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
    stableLpFee: 4e-4,
    stableLpFeeRateOfTotalFee: 0.5
  }
];

// evm/constants/stableSwap/pools.ts
var isStableSwapSupported = (chainId) => STABLE_SUPPORTED_CHAIN_IDS.includes(chainId);
var STABLE_SUPPORTED_CHAIN_IDS = [ChainId4.BSC, ChainId4.BSC_TESTNET];
var STABLE_POOL_MAP = {
  [ChainId4.BSC]: pools,
  [ChainId4.BSC_TESTNET]: pools2
};

// evm/constants/stableSwap/index.ts
function getStableSwapPools(chainId) {
  if (!isStableSwapSupported(chainId)) {
    return [];
  }
  return STABLE_POOL_MAP[chainId] || [];
}

// evm/getStableSwapPairs.ts
function getStableSwapPairs(chainId) {
  const pools3 = getStableSwapPools(chainId);
  return pools3.map(
    ({
      token,
      quoteToken,
      stableSwapAddress,
      lpAddress,
      infoStableSwapAddress,
      stableLpFee,
      stableLpFeeRateOfTotalFee
    }) => {
      const token0 = deserializeToken(token);
      const token1 = deserializeToken(quoteToken);
      return createStableSwapPair(
        {
          token0,
          token1,
          reserve0: CurrencyAmount5.fromRawAmount(token0, "0"),
          reserve1: CurrencyAmount5.fromRawAmount(token1, "0")
        },
        stableSwapAddress,
        lpAddress,
        infoStableSwapAddress,
        stableLpFee,
        stableLpFeeRateOfTotalFee
      );
    }
  );
}
var stableSwapPairsByChainId = fromPairs_(
  STABLE_SUPPORTED_CHAIN_IDS.map((chainId) => [chainId, getStableSwapPairs(chainId)])
);

// evm/onchain/getPairs.ts
import { CurrencyAmount as CurrencyAmount7, Pair as Pair2 } from "@pancakeswap/sdk";
import { createMulticall } from "@pancakeswap/multicall";

// evm/utils/currency.ts
import { CurrencyAmount as CurrencyAmount6, Native, WNATIVE } from "@pancakeswap/sdk";
function wrappedCurrency(currency, chainId) {
  return (currency == null ? void 0 : currency.isNative) ? WNATIVE[chainId] : (currency == null ? void 0 : currency.isToken) ? currency : void 0;
}
function wrappedCurrencyAmount(currencyAmount, chainId) {
  const token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : void 0;
  return token && currencyAmount ? CurrencyAmount6.fromRawAmount(token, currencyAmount.quotient) : void 0;
}

// evm/abis/IPancakePair.json
var IPancakePair_default = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      }
    ],
    name: "Sync",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINIMUM_LIQUIDITY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getReserves",
    outputs: [
      {
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      },
      {
        internalType: "uint32",
        name: "blockTimestampLast",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "kLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "price0CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "price1CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "skim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "sync",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token0",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token1",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// evm/onchain/getPairs.ts
function getPairs(_0, _1) {
  return __async(this, arguments, function* (currencyPairs, { provider, chainId }) {
    const tokens = currencyPairs.map(([currencyA, currencyB]) => [
      wrappedCurrency(currencyA, chainId),
      wrappedCurrency(currencyB, chainId)
    ]);
    const pairAddresses = tokens.map(getPairAddress);
    const { multicallv2 } = createMulticall(provider);
    const reserveCalls = pairAddresses.map((address) => ({
      address,
      name: "getReserves",
      params: []
    }));
    const results = yield multicallv2({
      abi: IPancakePair_default,
      calls: reserveCalls,
      chainId,
      options: {
        requireSuccess: false
      }
    });
    const resultWithState = results.map((result, i) => {
      if (!result)
        return [1 /* NOT_EXISTS */, null];
      const tokenA = tokens[i][0];
      const tokenB = tokens[i][1];
      if (!tokenA || !tokenB || tokenA.equals(tokenB))
        return [3 /* INVALID */, null];
      const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
      const { reserve0, reserve1 } = result;
      return [
        2 /* EXISTS */,
        new Pair2(
          CurrencyAmount7.fromRawAmount(token0, reserve0.toString()),
          CurrencyAmount7.fromRawAmount(token1, reserve1.toString())
        )
      ];
    });
    const successfulResult = resultWithState.filter(
      (result) => Boolean(result[0] === 2 /* EXISTS */ && result[1])
    );
    return successfulResult.map(([, pair]) => pair);
  });
}
function getPairAddress([tokenA, tokenB]) {
  let addr = "";
  try {
    addr = tokenA && tokenB && !tokenA.equals(tokenB) ? Pair2.getAddress(tokenA, tokenB) : "";
  } catch (error) {
    console.error(error.msg, `- pairAddresses: ${tokenA == null ? void 0 : tokenA.address}-${tokenB == null ? void 0 : tokenB.address}`, `chainId: ${tokenA == null ? void 0 : tokenA.chainId}`);
  }
  return addr;
}

// evm/onchain/getStableSwapOutputAmount.ts
import { CurrencyAmount as CurrencyAmount8 } from "@pancakeswap/sdk";
import { createMulticall as createMulticall2 } from "@pancakeswap/multicall";

// evm/abis/StableSwapPair.json
var StableSwapPair_default = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "AddLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "admin_fee",
        type: "uint256"
      }
    ],
    name: "CommitNewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "DonateAdminFees",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "Kill",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "admin_fee",
        type: "uint256"
      }
    ],
    name: "NewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "old_A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "new_A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "initial_time",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "future_time",
        type: "uint256"
      }
    ],
    name: "RampA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidityImbalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "coin_amount",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidityOne",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "RevertParameters",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "t",
        type: "uint256"
      }
    ],
    name: "StopRampA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sold_id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokens_sold",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bought_id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokens_bought",
        type: "uint256"
      }
    ],
    name: "TokenExchange",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "Unkill",
    type: "event"
  },
  {
    inputs: [],
    name: "A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ADMIN_ACTIONS_DELAY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "FEE_DENOMINATOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "KILL_DEADLINE_DT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_ADMIN_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_A_CHANGE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_DECIMAL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MIN_RAMP_TIME",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "N_COINS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "PRECISION_MUL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "RATES",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "STABLESWAP_FACTORY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "uint256",
        name: "min_mint_amount",
        type: "uint256"
      }
    ],
    name: "add_liquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "admin_actions_deadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      }
    ],
    name: "admin_balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "admin_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "apply_new_fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "bool",
        name: "deposit",
        type: "bool"
      }
    ],
    name: "calc_token_amount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      }
    ],
    name: "calc_withdraw_one_coin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "coins",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "new_fee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "new_admin_fee",
        type: "uint256"
      }
    ],
    name: "commit_new_fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "donate_admin_fees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "min_dy",
        type: "uint256"
      }
    ],
    name: "exchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_A_time",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_admin_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      }
    ],
    name: "get_dy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      }
    ],
    name: "get_dy_underlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "get_virtual_price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initial_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initial_A_time",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[2]",
        name: "_coins",
        type: "address[2]"
      },
      {
        internalType: "uint256",
        name: "_A",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_admin_fee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "is_killed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "kill_deadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "kill_me",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_future_A",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_future_time",
        type: "uint256"
      }
    ],
    name: "ramp_A",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256[2]",
        name: "min_amounts",
        type: "uint256[2]"
      }
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "uint256",
        name: "max_burn_amount",
        type: "uint256"
      }
    ],
    name: "remove_liquidity_imbalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "min_amount",
        type: "uint256"
      }
    ],
    name: "remove_liquidity_one_coin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "revert_new_parameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "stop_rampget_A",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract PancakeStableSwapLP",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unkill_me",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdraw_admin_fees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// evm/onchain/getStableSwapOutputAmount.ts
function getStableSwapOutputAmount(_0, _1, _2) {
  return __async(this, arguments, function* (pair, inputAmount, { provider }) {
    const { multicallv2 } = createMulticall2(provider);
    const wrappedInputAmount = wrappedCurrencyAmount(inputAmount, inputAmount.currency.chainId);
    if (!wrappedInputAmount) {
      throw new Error(`No wrapped token amount found for input amount: ${inputAmount.currency.name}`);
    }
    const chainId = inputAmount.currency.chainId;
    const inputToken = wrappedInputAmount.currency;
    const outputToken = getOutputToken(pair, inputToken);
    const inputRawAmount = inputAmount.wrapped.quotient.toString();
    const isOutputToken0 = pair.token0.equals(outputToken);
    const args = isOutputToken0 ? [1, 0, inputRawAmount] : [0, 1, inputRawAmount];
    const call = {
      address: pair.stableSwapAddress,
      name: "get_dy",
      params: args
    };
    const result = yield multicallv2({
      abi: StableSwapPair_default,
      calls: [call],
      chainId,
      options: {
        requireSuccess: true
      }
    });
    return CurrencyAmount8.fromRawAmount(outputToken, result.toString());
  });
}

// evm/onchain/getStableSwapFee.ts
import { createMulticall as createMulticall3 } from "@pancakeswap/multicall";
import { CurrencyAmount as CurrencyAmount9 } from "@pancakeswap/sdk";

// evm/abis/InfoStableSwap.json
var InfoStableSwap_default = [
  {
    inputs: [],
    name: "FEE_DENOMINATOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "N_COINS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      }
    ],
    name: "PRECISION_MUL",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "swapPRECISION_MUL",
        type: "uint256[2]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      }
    ],
    name: "RATES",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "swapRATES",
        type: "uint256[2]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256[2]",
        name: "_balances",
        type: "uint256[2]"
      }
    ],
    name: "_xp_mem",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "result",
        type: "uint256[2]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      }
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "swapBalances",
        type: "uint256[2]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "calc_coins_amount",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "",
        type: "uint256[2]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256[2]",
        name: "_balances",
        type: "uint256[2]"
      },
      {
        internalType: "uint256",
        name: "amp",
        type: "uint256"
      }
    ],
    name: "get_D_mem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      }
    ],
    name: "get_add_liquidity_fee",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "liquidityFee",
        type: "uint256[2]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      }
    ],
    name: "get_add_liquidity_mint_amount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      }
    ],
    name: "get_exchange_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "exFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "exAdminFee",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      }
    ],
    name: "get_remove_liquidity_imbalance_fee",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "liquidityFee",
        type: "uint256[2]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      }
    ],
    name: "get_remove_liquidity_one_coin_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "adminFee",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swap",
        type: "address"
      }
    ],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// evm/constants/common.ts
import { JSBI as JSBI5, Percent as Percent5 } from "@pancakeswap/sdk";
var BIG_INT_TEN = JSBI5.BigInt(10);
var BIPS_BASE = JSBI5.BigInt(1e4);
var MIN_BNB = JSBI5.exponentiate(BIG_INT_TEN, JSBI5.BigInt(16));
var BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent5(JSBI5.BigInt(50), BIPS_BASE);

// evm/constants/exchange.ts
import { ChainId as ChainId9, WBNB as WBNB3, WNATIVE as WNATIVE2 } from "@pancakeswap/sdk";
var ROUTER_ADDRESS = {
  [ChainId9.ETHEREUM]: "0x3BC722f252C7bAE2f55647e49aDcB9d33Ff6eBcC",
  [ChainId9.GOERLI]: "0x3BC722f252C7bAE2f55647e49aDcB9d33Ff6eBcC",
  [ChainId9.BSC]: "0x09bfaA0E9B73D4741AE3721b6F82409e79695eBF",
  [ChainId9.BSC_TESTNET]: ""
};
var STABLE_SWAP_INFO_ADDRESS = {
  [ChainId9.ETHEREUM]: "",
  [ChainId9.GOERLI]: "",
  [ChainId9.BSC]: "0xD962c62E53978BfD314f0A2FAD83abEC7d36B112",
  [ChainId9.BSC_TESTNET]: ""
};
var BASES_TO_CHECK_TRADES_AGAINST = {
  [ChainId9.ETHEREUM]: [
    WNATIVE2[ChainId9.ETHEREUM],
    USDC[ChainId9.ETHEREUM],
    USDT[ChainId9.ETHEREUM],
    BUSD[ChainId9.ETHEREUM],
    WBNB3[ChainId9.ETHEREUM]
  ],
  [ChainId9.GOERLI]: [WNATIVE2[ChainId9.GOERLI], USDC[ChainId9.GOERLI], BUSD[ChainId9.GOERLI]],
  [ChainId9.BSC]: [
    bscTokens.wbnb,
    bscTokens.cake,
    bscTokens.busd,
    bscTokens.usdt,
    bscTokens.dai,
    bscTokens.usdc
  ],
  [ChainId9.BSC_TESTNET]: [bscTestnetTokens.wbnb, bscTestnetTokens.cake, bscTestnetTokens.busd]
};
var ADDITIONAL_BASES = {
  [ChainId9.BSC]: {
    // SNFTS-SFUND
    [bscTokens.snfts.address]: [bscTokens.sfund]
  }
};
var CUSTOM_BASES = {
  [ChainId9.BSC]: {
    [bscTokens.axlusdc.address]: [bscTokens.usdt]
  }
};
var SUGGESTED_BASES = {
  [ChainId9.ETHEREUM]: [USDC[ChainId9.ETHEREUM], WBNB3[ChainId9.ETHEREUM], BUSD[ChainId9.ETHEREUM], USDT[ChainId9.ETHEREUM]],
  [ChainId9.GOERLI]: [USDC[ChainId9.GOERLI], WNATIVE2[ChainId9.GOERLI], BUSD[ChainId9.GOERLI]],
  [ChainId9.BSC]: [bscTokens.cake, bscTokens.pay, bscTokens.usdt, bscTokens.usdc],
  [ChainId9.BSC_TESTNET]: [bscTestnetTokens.wbnb, bscTestnetTokens.cake, bscTestnetTokens.busd]
};
var BASES_TO_TRACK_LIQUIDITY_FOR = {
  [ChainId9.ETHEREUM]: [
    USDC[ChainId9.ETHEREUM],
    WNATIVE2[ChainId9.ETHEREUM],
    BUSD[ChainId9.ETHEREUM],
    USDT[ChainId9.ETHEREUM],
    WBNB3[ChainId9.ETHEREUM]
  ],
  [ChainId9.GOERLI]: [USDC[ChainId9.GOERLI], WNATIVE2[ChainId9.GOERLI], BUSD[ChainId9.GOERLI]],
  [ChainId9.BSC]: [bscTokens.wbnb, bscTokens.dai, bscTokens.busd, bscTokens.usdt, bscTokens.cake],
  [ChainId9.BSC_TESTNET]: [bscTestnetTokens.wbnb, bscTestnetTokens.cake, bscTestnetTokens.busd]
};
var PINNED_PAIRS = {
  [ChainId9.ETHEREUM]: [
    [WNATIVE2[ChainId9.ETHEREUM], USDC[ChainId9.ETHEREUM]],
    [WBNB3[ChainId9.ETHEREUM], USDC[ChainId9.ETHEREUM]],
    [WBNB3[ChainId9.ETHEREUM], BUSD[ChainId9.ETHEREUM]],
    [WBNB3[ChainId9.ETHEREUM], USDT[ChainId9.ETHEREUM]],
    [WBNB3[ChainId9.ETHEREUM], WNATIVE2[ChainId9.ETHEREUM]]
  ],
  [ChainId9.BSC]: [
    [bscTokens.cake, bscTokens.wbnb],
    [bscTokens.busd, bscTokens.usdt],
    [bscTokens.dai, bscTokens.usdt]
  ]
};

// evm/onchain/getStableSwapFee.ts
function getStableSwapFeeCall(pair, inputAmount) {
  const { chainId } = inputAmount.currency;
  const wrappedInputAmount = wrappedCurrencyAmount(inputAmount, chainId);
  if (!wrappedInputAmount) {
    throw new Error(`No wrapped token amount found for input amount: ${inputAmount.currency.name}`);
  }
  const { stableSwapAddress } = pair;
  const inputToken = wrappedInputAmount.currency;
  const outputToken = getOutputToken(pair, inputToken);
  const inputRawAmount = inputAmount.wrapped.quotient.toString();
  const isOutputToken0 = pair.token0.equals(outputToken);
  const args = isOutputToken0 ? [stableSwapAddress, 1, 0, inputRawAmount] : [stableSwapAddress, 0, 1, inputRawAmount];
  return {
    address: pair.infoStableSwapAddress || STABLE_SWAP_INFO_ADDRESS[chainId],
    name: "get_exchange_fee",
    params: args
  };
}
function getStableSwapFee(_0, _1, _2) {
  return __async(this, arguments, function* (pair, inputAmount, { provider }) {
    const chainId = inputAmount.currency.chainId;
    const { multicallv2 } = createMulticall3(provider);
    const call = getStableSwapFeeCall(pair, inputAmount);
    const outputToken = getOutputToken(pair, inputAmount.currency);
    const [[feeRaw, adminFeeRaw]] = yield multicallv2({
      abi: InfoStableSwap_default,
      calls: [call],
      chainId,
      options: {
        requireSuccess: true
      }
    });
    return {
      fee: CurrencyAmount9.fromRawAmount(outputToken, feeRaw.toString()),
      adminFee: CurrencyAmount9.fromRawAmount(outputToken, adminFeeRaw.toString())
    };
  });
}

// evm/getBestTradeFromStablePools.ts
function getBestTradeFromStablePools(_0, _1, _2) {
  return __async(this, arguments, function* (amount, output, { maxHops, provider }) {
    const {
      currency: { chainId }
    } = amount;
    const pairs = stableSwapPairsByChainId[chainId] || [];
    const routes = computeAllRoutes(amount.currency, output, pairs, maxHops);
    const trades = yield Promise.all(routes.map((r) => getStableTrade(amount, r, { provider })));
    if (!trades.length) {
      return null;
    }
    let bestTrade = trades[0];
    for (let i = 1; i < trades.length; i += 1) {
      const trade = trades[i];
      if (trade.outputAmount.greaterThan(bestTrade.outputAmount)) {
        bestTrade = trade;
      }
    }
    return bestTrade;
  });
}
function getStableTrade(_0, _1, _2) {
  return __async(this, arguments, function* (amountIn, pairs, { provider }) {
    let outputToken = amountIn.currency;
    let outputAmount = amountIn;
    const pairsWithPrice = [];
    for (const pair of pairs) {
      const inputAmount = outputAmount;
      const results = yield Promise.all([
        getStableSwapOutputAmount(pair, inputAmount, { provider }),
        getStableSwapFee(pair, inputAmount, { provider })
      ]);
      outputAmount = results[0];
      const fees = results[1];
      outputToken = getOutputToken(pair, outputToken);
      const { fee, adminFee } = getFeePercent(inputAmount, outputAmount, fees);
      pairsWithPrice.push(__spreadProps(__spreadValues({}, pair), {
        price: new Price2({ baseAmount: inputAmount, quoteAmount: outputAmount.add(fees.fee) }),
        fee,
        adminFee
      }));
    }
    return createTradeWithStableSwap({
      routeType: 1 /* STABLE_SWAP */,
      inputAmount: amountIn,
      outputAmount,
      pairs: pairsWithPrice,
      tradeType: TradeType2.EXACT_INPUT
    });
  });
}
function computeAllRoutes(input, output, pairs, maxHops = 3) {
  const poolsUsed = Array(pairs.length).fill(false);
  const routes = [];
  const computeRoutes = (currencyIn, currencyOut, currentRoute, _previousCurrencyOut) => {
    if (currentRoute.length > maxHops) {
      return;
    }
    if (currentRoute.length > 0 && involvesToken(currentRoute[currentRoute.length - 1], currencyOut)) {
      routes.push([...currentRoute]);
      return;
    }
    for (let i = 0; i < pairs.length; i++) {
      if (poolsUsed[i]) {
        continue;
      }
      const curPool = pairs[i];
      const previousCurrencyOut = _previousCurrencyOut || currencyIn;
      if (!involvesToken(curPool, previousCurrencyOut)) {
        continue;
      }
      const currentTokenOut = getOutputToken(curPool, previousCurrencyOut);
      currentRoute.push(curPool);
      poolsUsed[i] = true;
      computeRoutes(currencyIn, currencyOut, currentRoute, currentTokenOut);
      poolsUsed[i] = false;
      currentRoute.pop();
    }
  };
  computeRoutes(input, output, []);
  return routes;
}

// evm/getBestTradeFromV2.ts
import { Trade as Trade2, TradeType as TradeType3, isTradeBetter } from "@pancakeswap/sdk";

// evm/getAllCommonPairs.ts
import flatMap from "lodash/flatMap";
var PairState = /* @__PURE__ */ ((PairState2) => {
  PairState2[PairState2["LOADING"] = 0] = "LOADING";
  PairState2[PairState2["NOT_EXISTS"] = 1] = "NOT_EXISTS";
  PairState2[PairState2["EXISTS"] = 2] = "EXISTS";
  PairState2[PairState2["INVALID"] = 3] = "INVALID";
  return PairState2;
})(PairState || {});
function getAllCommonPairs(_0, _1, _2) {
  return __async(this, arguments, function* (currencyA, currencyB, { provider }) {
    var _a, _b, _c, _d, _e;
    const chainId = currencyA.chainId;
    if (!chainId || chainId !== currencyB.chainId) {
      return [];
    }
    const [tokenA, tokenB] = chainId ? [wrappedCurrency(currencyA, chainId), wrappedCurrency(currencyB, chainId)] : [void 0, void 0];
    const common = (_a = BASES_TO_CHECK_TRADES_AGAINST[chainId]) != null ? _a : [];
    const additionalA = tokenA ? (_c = (_b = ADDITIONAL_BASES[chainId]) == null ? void 0 : _b[tokenA.address]) != null ? _c : [] : [];
    const additionalB = tokenB ? (_e = (_d = ADDITIONAL_BASES[chainId]) == null ? void 0 : _d[tokenB.address]) != null ? _e : [] : [];
    const bases = [...common, ...additionalA, ...additionalB];
    const basePairs = flatMap(
      bases,
      (base) => bases.map((otherBase) => [base, otherBase])
    );
    const allPairCombinations = getAllPairCombinations(tokenA, tokenB, bases, basePairs, chainId);
    const allPairs = yield getPairs(allPairCombinations, { chainId, provider });
    return Object.values(
      allPairs.reduce((memo, curr) => {
        var _a2;
        memo[curr.liquidityToken.address] = (_a2 = memo[curr.liquidityToken.address]) != null ? _a2 : curr;
        return memo;
      }, {})
    );
  });
}
var getAllPairCombinations = (tokenA, tokenB, bases, basePairs, chainId) => {
  return tokenA && tokenB ? [
    // the direct pair
    [tokenA, tokenB],
    // token A against all bases
    ...bases.map((base) => [tokenA, base]),
    // token B against all bases
    ...bases.map((base) => [tokenB, base]),
    // each base against all bases
    ...basePairs
  ].filter((tokens) => Boolean(tokens[0] && tokens[1])).filter(([t0, t1]) => t0.address !== t1.address).filter(([tokenA_, tokenB_]) => {
    if (!chainId)
      return true;
    const customBases = CUSTOM_BASES[chainId];
    const customBasesA = customBases == null ? void 0 : customBases[tokenA_.address];
    const customBasesB = customBases == null ? void 0 : customBases[tokenB_.address];
    if (!customBasesA && !customBasesB)
      return true;
    if (customBasesA && !customBasesA.find((base) => tokenB_.equals(base)))
      return false;
    if (customBasesB && !customBasesB.find((base) => tokenA_.equals(base)))
      return false;
    return true;
  }) : [];
};

// evm/getBestTradeFromV2.ts
var getBestTradeFromV2ExactIn = createGetBestTradeFromV2(TradeType3.EXACT_INPUT);
var getBestTradeFromV2ExactOut = createGetBestTradeFromV2(TradeType3.EXACT_OUTPUT);
function createGetBestTradeFromV2(tradeType) {
  function getBestTrade(pairs, amountIn, output, options) {
    if (tradeType === TradeType3.EXACT_INPUT) {
      return Trade2.bestTradeExactIn(pairs, amountIn, output, options);
    }
    return Trade2.bestTradeExactOut(pairs, output, amountIn, options);
  }
  return function bestTradeFromV2(amountIn, output, options) {
    return __async(this, null, function* () {
      var _b, _c;
      const _a = options, { provider, allCommonPairs } = _a, restOptions = __objRest(_a, ["provider", "allCommonPairs"]);
      const { maxHops = 3 } = restOptions;
      const getAllowedPairs = () => __async(this, null, function* () {
        if (Array.isArray(allCommonPairs)) {
          return allCommonPairs;
        }
        if (allCommonPairs) {
          return allCommonPairs(amountIn.currency, output);
        }
        return getAllCommonPairs(amountIn.currency, output, { provider });
      });
      const allowedPairs = yield getAllowedPairs();
      if (!allowedPairs.length) {
        return null;
      }
      if (maxHops === 1) {
        return (_b = getBestTrade(allowedPairs, amountIn, output, restOptions)[0]) != null ? _b : null;
      }
      let bestTradeSoFar = null;
      for (let i = 1; i <= maxHops; i++) {
        const currentTrade = (_c = getBestTrade(allowedPairs, amountIn, output, __spreadProps(__spreadValues({}, restOptions), {
          maxHops: i,
          maxNumResults: 1
        }))[0]) != null ? _c : null;
        if (isTradeBetter(bestTradeSoFar, currentTrade, BETTER_TRADE_LESS_HOPS_THRESHOLD)) {
          bestTradeSoFar = currentTrade;
        }
      }
      return bestTradeSoFar;
    });
  };
}

// evm/getBestTradeWithStableSwap.ts
import { CurrencyAmount as CurrencyAmount12, Price as Price3 } from "@pancakeswap/sdk";
function getBestTradeWithStableSwap(baseTrade, stableSwapPairs, options) {
  return __async(this, null, function* () {
    const { provider } = options;
    const { inputAmount, route, tradeType } = baseTrade;
    if (!stableSwapPairs.length) {
      return createTradeWithStableSwapFromV2Trade(baseTrade);
    }
    const findStableSwapPair = (pair) => stableSwapPairs.find((p) => isSamePair(p, pair));
    let outputAmount = inputAmount;
    let outputToken = inputAmount.currency;
    const shouldRecalculateOutputAmount = () => !outputToken.equals(outputAmount.currency);
    const getLatestOutputAmount = () => __async(this, null, function* () {
      if (outputAmount.currency.equals(inputAmount.currency) && outputToken.equals(baseTrade.outputAmount.currency)) {
        return baseTrade.outputAmount;
      }
      return shouldRecalculateOutputAmount() ? getOutputAmountFromV2(outputAmount, outputToken, options) : outputAmount;
    });
    let routeType = null;
    const setCurrentRouteType = (type) => {
      routeType = routeType === null || routeType === type ? type : 2 /* MIXED */;
    };
    const pairsWithStableSwap = [];
    for (const [index, pair] of route.pairs.entries()) {
      const stableSwapPair = findStableSwapPair(pair);
      if (stableSwapPair) {
        const stableInputAmount = yield getLatestOutputAmount();
        const results = yield Promise.all([
          getStableSwapOutputAmount(stableSwapPair, stableInputAmount, { provider }),
          getStableSwapFee(stableSwapPair, stableInputAmount, { provider })
        ]);
        outputAmount = results[0];
        const fees = results[1];
        outputToken = getOutputToken(stableSwapPair, outputToken);
        const { fee, adminFee } = getFeePercent(stableInputAmount, outputAmount, fees);
        pairsWithStableSwap.push(__spreadProps(__spreadValues({}, stableSwapPair), {
          price: new Price3({ baseAmount: stableInputAmount, quoteAmount: outputAmount.add(fees.fee) }),
          fee,
          adminFee
        }));
        setCurrentRouteType(1 /* STABLE_SWAP */);
        continue;
      }
      outputToken = getOutputToken(pair, outputToken);
      if (index === route.pairs.length - 1) {
        outputAmount = yield getLatestOutputAmount();
      }
      pairsWithStableSwap.push(pair);
      setCurrentRouteType(0 /* V2 */);
    }
    if (routeType === null) {
      throw new Error(`No valid route found`);
    }
    return createTradeWithStableSwap({
      routeType,
      pairs: pairsWithStableSwap,
      inputAmount,
      // Make sure the output currency is the same as the output currency of v2 trade
      outputAmount: CurrencyAmount12.fromFractionalAmount(
        baseTrade.outputAmount.currency,
        outputAmount.numerator,
        outputAmount.denominator
      ),
      tradeType
    });
  });
}
function getOutputAmountFromV2(inputAmount, outputToken, options) {
  return __async(this, null, function* () {
    const trade = yield getBestTradeFromV2ExactIn(inputAmount, outputToken, options);
    if (!trade) {
      throw new Error(`Cannot get valid trade from ${inputAmount.currency.name} to ${outputToken.name}`);
    }
    return trade.outputAmount;
  });
}

// evm/getBestTrade.ts
var getBestTradeExactIn = createGetBestTrade(TradeType5.EXACT_INPUT);
var getBestTradeExactOut = createGetBestTrade(TradeType5.EXACT_OUTPUT);
function createGetBestTrade(tradeType) {
  const isExactIn = tradeType === TradeType5.EXACT_INPUT;
  const getBestTradeFromV2 = isExactIn ? getBestTradeFromV2ExactIn : getBestTradeFromV2ExactOut;
  return function getBestTrade(amountIn, output, options) {
    return __async(this, null, function* () {
      const { provider } = options;
      const {
        currency: { chainId }
      } = amountIn;
      const bestTradeV2 = yield getBestTradeFromV2(amountIn, output, options);
      const bestTradeStable = (bestTradeV2 || isExactIn) && (yield getBestTradeFromStablePools(
        (bestTradeV2 == null ? void 0 : bestTradeV2.inputAmount) || amountIn,
        (bestTradeV2 == null ? void 0 : bestTradeV2.outputAmount.currency) || output,
        options
      ));
      if (!bestTradeV2) {
        if (bestTradeStable) {
          return bestTradeStable;
        }
        return null;
      }
      const stableSwapPairs = stableSwapPairsByChainId[chainId] || [];
      const bestTradeWithStableSwap = yield getBestTradeWithStableSwap(bestTradeV2, stableSwapPairs, { provider });
      const { outputAmount: outputAmountWithStableSwap } = bestTradeWithStableSwap;
      if (bestTradeStable && bestTradeStable.outputAmount.greaterThan(outputAmountWithStableSwap) && bestTradeStable.outputAmount.greaterThan(bestTradeV2.outputAmount)) {
        return bestTradeStable;
      }
      if (outputAmountWithStableSwap.lessThan(bestTradeV2.outputAmount)) {
        return createTradeWithStableSwapFromV2Trade(bestTradeV2);
      }
      return bestTradeWithStableSwap;
    });
  };
}

// evm/trade.ts
import invariant5 from "tiny-invariant";
import {
  TradeType as TradeType6,
  ZERO as ZERO4,
  CurrencyAmount as CurrencyAmount14,
  Fraction,
  ONE as ONE2,
  Price as Price5,
  computePriceImpact
} from "@pancakeswap/sdk";

// evm/utils/route.ts
import { Price as Price4 } from "@pancakeswap/sdk";
function getMidPrice(route) {
  const prices = [];
  for (const [i, pair] of route.pairs.entries()) {
    if (isStableSwapPair(pair)) {
      prices.push(route.path[i].wrapped.equals(pair.price.baseCurrency.wrapped) ? pair.price : pair.price.invert());
      continue;
    }
    prices.push(
      route.path[i].wrapped.equals(pair.token0.wrapped) ? new Price4(pair.reserve0.currency, pair.reserve1.currency, pair.reserve0.quotient, pair.reserve1.quotient) : new Price4(pair.reserve1.currency, pair.reserve0.currency, pair.reserve1.quotient, pair.reserve0.quotient)
    );
  }
  const reduced = prices.slice(1).reduce((accumulator, currentValue) => accumulator.multiply(currentValue), prices[0]);
  return new Price4(route.input, route.output, reduced.denominator, reduced.numerator);
}

// evm/trade.ts
var Trade4 = {
  maximumAmountIn,
  minimumAmountOut,
  executionPrice,
  priceImpact
};
function maximumAmountIn(trade, slippageTolerance) {
  invariant5(!slippageTolerance.lessThan(ZERO4), "SLIPPAGE_TOLERANCE");
  if (trade.tradeType === TradeType6.EXACT_INPUT) {
    return trade.inputAmount;
  }
  const slippageAdjustedAmountIn = new Fraction(ONE2).add(slippageTolerance).multiply(trade.inputAmount.quotient).quotient;
  return CurrencyAmount14.fromRawAmount(trade.inputAmount.currency, slippageAdjustedAmountIn);
}
function minimumAmountOut(trade, slippageTolerance) {
  invariant5(!slippageTolerance.lessThan(ZERO4), "SLIPPAGE_TOLERANCE");
  if (trade.tradeType === TradeType6.EXACT_OUTPUT) {
    return trade.outputAmount;
  }
  const slippageAdjustedAmountOut = new Fraction(ONE2).add(slippageTolerance).invert().multiply(trade.outputAmount.quotient).quotient;
  return CurrencyAmount14.fromRawAmount(trade.outputAmount.currency, slippageAdjustedAmountOut);
}
function executionPrice({
  inputAmount,
  outputAmount
}) {
  return new Price5(inputAmount.currency, outputAmount.currency, inputAmount.quotient, outputAmount.quotient);
}
function priceImpact({
  route,
  inputAmount,
  outputAmount
}) {
  return computePriceImpact(getMidPrice(route), inputAmount, outputAmount);
}

// evm/route.ts
var Route = {
  midPrice: getMidPrice
};
export {
  PairState,
  Route,
  RouteType,
  StableSwap,
  Trade4 as Trade,
  createStableSwapPair,
  getAllCommonPairs,
  getBestTradeExactIn,
  getBestTradeExactOut,
  isStableSwapPair,
  stableSwapPairsByChainId
};
